try {
    require('sticky-table-headers')();
} catch (e) {}


$(document).ready(function() {
    $('.table-sticky').stickyTableHeaders();
});
